import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

import { ensureCurrentTimezoneData } from 'utils/timezoneData';

import { setupSentry } from './lib/sentry';

import 'styles/custom.scss';
import 'styles/ql-editor-content-styles.scss';

setupSentry();

const render = async (): Promise<void> => {
  try {
    if (await ensureCurrentTimezoneData()) {
      Sentry.setTag('timezone_data', 'polyfilled');
    }
  } catch (error) {
    Sentry.captureException(error);
  }

  // Imported after the timezone data so no module caches a stale Intl formatter.
  const { default: App } = await import('app');
  createRoot(document.getElementById('root')!).render(<App />);
};

render().catch((error) => Sentry.captureException(error));
